export function getApiUrl(subdomain: string): string {
  if (subdomain.startsWith('http')) {
    return subdomain;
  }
  const { hostname } = window.location;
  const parts = hostname.split('.');
  const mainDomain = parts.length >= 2 ? parts.slice(-2).join('.') : hostname;
  return `https://${subdomain}.${mainDomain}`;
}
